export default __webpack_public_path__ + "static/media/garbage-bin.4edfa80b.png";